import { render, staticRenderFns } from "./dashboard-products-sold.vue?vue&type=template&id=477f9200&"
import script from "./dashboard-products-sold.vue?vue&type=script&lang=js&"
export * from "./dashboard-products-sold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports